"use client";

const openLayers: string[] = [];

export function registerLayer(id: string) {
  openLayers.push(id);
  let registered = true;

  return () => {
    if (!registered) return;
    registered = false;
    const index = openLayers.lastIndexOf(id);
    if (index >= 0) openLayers.splice(index, 1);
  };
}

export function isTopLayer(id: string) {
  return openLayers[openLayers.length - 1] === id;
}
